<template>
    <div class="row" id="new-group-form">
        <form @submit.prevent="currentGroup ? updateGroup() : addNewGroup()" class="form-inline">
        	<div class="form-group">
                <label class="sr-only" for="group_name">Group Name</label>
    			<input id="group_name" class="form-control" v-model="form.name" placeholder="Group Name" />
        	</div>
			<div class="form-group">
				<label class="sr-only" for="capacity">Capacity</label>
				<input id="capacity" class="form-control" v-model="form.capacity" placeholder="Capacity" />
			</div>
            <div class="form-group">
            <button type="submit" class="btn btn-success">{{ buttonLabel }}</button>
        </div>
        </form>
    </div>
</template>

<style scoped>
    #new-group-form {
        margin-bottom: 8px;
    }
</style>

<script>
    import Form from '../utils/Form';

	export default {
        props: [
            'group'
        ],
		data: function () {
			return {
                currentGroup: this.group,
                form: new Form({
                    name: this.currentGroup ? this.currentGroup.name : null,
					capacity: this.currentGroup ? this.currentGroup.capacity : null,
                }),
                buttonLabel: this.currentGroup ? 'Update Group' : 'Add Group'
			}
		},
		computed: {

		},
		mounted() {
				console.log('Add Group component mounted.');
                this.resetForm();
		},
		methods: {
            resetForm() {
                console.log('resetForm');
                console.log(this.currentGroup);
                this.form.name = this.currentGroup ? this.currentGroup.name : null;
            },

            addNewGroup() {
                this.form.post(`/api/v1/groups`)
                    .then(response => {
                        console.log('addNewGroup response');
                        console.log(response);
                        this.$emit('group-changed');
                        console.log('Resetting form');
                        this.resetForm();
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem saving the group.', type: 'error'});
                    });
            },

            updateGroup() {
                this.form.put(`/api/v1/groups/${this.currentGroup.id}`)
                    .then(response => {
                        this.$emit('group-changed');
                        this.currentGroup = response.data;
                        this.resetForm();
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem saving the group.', type: 'error'});
                    });
            },

			// addNewGroup() {
			// 	console.log('addNewGroup called');
			// 	// this.loadingInstance = Loading.service({text: "Loading events... please wait"});
			// 	axios.post('/api/v1/groups', {
			// 		group: this.group
			// 	}).then((response) => {
			// 		// this.loadingInstance.close();
			// 		console.log(response.data);
			// 		this.resetForm();
			// 		this.$emit('group-added');
			// 	}).catch((error) => {
			// 		// this.loadingInstance.close();
			// 		this.$message({message: 'There was a problem saving the group.', type: 'error'});
			// 	});
			// },
            destroyed() {
                this.form = null;
            }

		}
	}
</script>
